import "core-js/modules/web.dom.iterable";
var directiveFiles = require.context('./directiveFiles', true, /\.js$/);
directiveFiles.keys().forEach(function (ele) {
  directiveFiles(ele);
});